import Button from "../components/button/Button"
import FAQItem from "../components/questions/Questions"
import styles from "./SixthScreen.module.css"

const SixthScreen=()=>{


    return <>
    <div className={styles.title}>אתן שואלות ואני עונה</div>
    <FAQItem question="קורס ציור מתאים גם למי שאף פעם לא ציירה?" answer="כן! גם הפרונטלי וגם הדיגיטלי בנויים בצורה כזאת שאני מתחילה ללמד מהבסיס את כל מה שצריך לדעת, בניתי קורס מרוכז שכל מה שתצטרכי לעשות זה לעקוב אחר השלבים ולבצע אותם."/>
    <FAQItem question="מה קורה בסיום הקורס? אם יהיו לי שאלות,בעיות או דברים שאצטרך בהם חיזוק?" answer="הקורסים וההשתלמויות אצלי כוללים מענה אישי לכל אחת, לצורך התייעצויות, שיתופים, שאלות וחששות, אני כאן עבורך."/>
    <FAQItem question="כמה בנות יש בכיתה בקורסים הפרונטליים?" answer="יש אופציה לבחור אחת על אחת או עד 2 בכיתה. 
מאוד חשוב לי שהקורס יהיה עם הליווי הכי צמוד שאפשר."/>
    <FAQItem question="מתלבטת אם לבחור בקורס ציורים הדיגיטלי או הפרונטלי, מה ההבדל?" answer="קורס דיגיטלי זמין 24/7, מה שמאפשר לך ללמוד מכל מקום בעולם בקצב שלך ובכל שעה שנוחה לך.
בקורס הפרונטלי יש לך אינטרקציה ישירה איתי, את נמצאת מולי, ואני שם כדי לתקן אותך פיזית ולהעיר באותו הרגע.
בכל אחת מהאופציות יש לך מענה אישי שלי, שאוכל לתת לך משוב על תרגולך.
תבחרי מה שמתאים עבורך."/>
    <FAQItem question="איפה מתקיימים הקורסים וההשתלמויות?" answer="הלימוד הפרונטלי מתקיים במושב מעונה בסטודיו שלי, הקורס הדיגיטלי- מכל מקום שנוח לך."/>
   <Button text="מעיין, בואי נדבר!"/>
  
    </>
}
export default SixthScreen